import { Typography } from 'antd';
import { type ReactNode } from 'react';

import type { ModelProduct, ModelSelectProducts } from '@app/api/Products';

const { Text } = Typography;
export const makeProductTitle = (
  product: ModelProduct,
  warehouseProductsMap?: Map<number, ModelSelectProducts>
): ReactNode => {
  const { Name } = product;
  const warehouseProduct = warehouseProductsMap?.get(product.Id);

  const showExtra = !!warehouseProductsMap && !!warehouseProduct;

  return (
    <table style={{ width: '100%', minWidth: '714px' }}>
      <tbody>
        <tr>
          <td style={{ width: showExtra ? '40%' : '100%' }}>
            {Name ?? 'Без названия'}
          </td>
          {showExtra && (
            <>
              <td
                style={{ width: '20%', minWidth: '100px', textAlign: 'center' }}
              >
                x{warehouseProduct?.CountAvailable ?? 0} шт.
              </td>
              <td
                style={{ width: '20%', minWidth: '100px', textAlign: 'center' }}
              >
                <Text type="secondary">
                  {warehouseProduct?.Supplier ?? 'Без поставщика'}
                </Text>
              </td>
              <td
                style={{ width: '15%', minWidth: '100px', textAlign: 'right' }}
              >
                {warehouseProduct?.PriceOfSale ?? 0}
              </td>
            </>
          )}
        </tr>
      </tbody>
    </table>
  );
};
